import React, {ReactElement} from 'react';
import NxCashInput, {NxCashInputProps} from '../cash/nxCashInput/NxCashInput';
import {NxFormikCashInput, NxFormikCashInputProps} from '../cash/nxCashInput/NxFormikCashInput';

export type NxPercentageInputProps = Omit<NxCashInputProps, 'currency'>;

// undefined clears input
const NxPercentageInput = (props: NxPercentageInputProps): React.ReactElement => <NxCashInput
  positionAbsoluteError={false}
  {...props}
  currency='%' />;

export default NxPercentageInput;


export type NxFormikPercentageInputProps = Omit<NxFormikCashInputProps, 'currency'>;

/**
 * For invalid numbers, component provides null to the model
 */
export const NxFormikPercentageInput = (props: NxFormikPercentageInputProps): ReactElement =>
  <NxFormikCashInput {...props} currency='%' />;
